import { getInlineLoader } from "../Helpers";

export default function MainLoader() {
  return <div className="MainLoader mSupportLoading">{getInlineLoader()}</div>;
}

